import React, { useState } from 'react';
import { MantineProvider } from '@mantine/core';
import {
  DefaultTheme,
  ThemeProvider as SCThemeProvider,
} from 'styled-components';
import { darkColors, lightColors } from './colors';
import { useHotkeys } from '@mantine/hooks';

type AppSettings = {
  currentTheme: DefaultTheme;
  isDarkMode: boolean;
  toggleDarkMode: () => void;
};

const AppSettingsContext = React.createContext<AppSettings>({
  currentTheme: darkColors,
  isDarkMode: true,
  toggleDarkMode: () => {
    return;
  },
});

export const useAppSettings = () => {
  return React.useContext(AppSettingsContext);
};

export function AppSettingsProvider({ children }: React.PropsWithChildren) {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(
    localStorage.getItem('color-scheme') !== 'light',
  );

  const handleDarkModeChange = () => {
    setIsDarkMode((prevMode) => {
      localStorage.setItem('color-scheme', !prevMode ? 'dark' : 'light');
      return !prevMode;
    });
  };

  // useHotkeys([['mod+l', handleDarkModeChange]]);

  return (
    <AppSettingsContext.Provider
      value={{
        currentTheme: darkColors,
        isDarkMode: true,
        toggleDarkMode: () => {},
      }}
    >
      <SCThemeProvider theme={true ? darkColors : lightColors}>
        <MantineProvider forceColorScheme={true ? 'dark' : 'light'}>
          {children}
        </MantineProvider>
      </SCThemeProvider>
    </AppSettingsContext.Provider>
  );
}
